import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatCurrency';
import { conversionSince, formatPeriod, formatShortDate } from '../../utils/partnerPortal';

/**
 * Locales atribuidos al partner: nombre, etapa, desde cuándo y comisión generada (RES-93).
 * Influencer ve además hasta cuándo cobra por cada local; CM no tiene fin.
 */
function PartnerConversionsTable({ conversions = [], program, locale }) {
  const { t } = useTranslation();
  const isInfluencer = program === 'influencer';

  return (
    <section className="pp-card" aria-labelledby="pp-conversions-title">
      <h2 id="pp-conversions-title" className="pp-card-title">
        {t('partnerPortal.conversions.title')}
      </h2>
      {conversions.length === 0 ? (
        <p className="pp-empty" data-testid="pp-conversions-empty">
          {t('partnerPortal.conversions.empty')}
        </p>
      ) : (
        <div className="pp-table-wrap">
          <table className="pp-table" data-testid="pp-conversions">
            <thead>
              <tr>
                <th scope="col">{t('partnerPortal.conversions.location')}</th>
                <th scope="col">{t('partnerPortal.conversions.stage')}</th>
                <th scope="col">{t('partnerPortal.conversions.since')}</th>
                <th scope="col" className="pp-num">
                  {t('partnerPortal.conversions.commission')}
                </th>
                {isInfluencer && <th scope="col">{t('partnerPortal.conversions.window')}</th>}
              </tr>
            </thead>
            <tbody>
              {conversions.map((c, index) => (
                <tr key={`${c.organizationName || 'local'}-${c.attributedAt || index}`}>
                  <td>
                    {c.organizationName || t('partnerPortal.conversions.unnamed')}
                    {c.billingMode === 'resale' && (
                      <span className="pp-badge pp-badge--neutral">
                        {t('partnerPortal.conversions.resale')}
                      </span>
                    )}
                  </td>
                  <td>
                    <span className={`pp-badge pp-stage--${c.stage}`} data-stage={c.stage}>
                      {t(`partnerPortal.stages.${c.stage}`)}
                    </span>
                  </td>
                  <td>{formatShortDate(conversionSince(c), locale) || '—'}</td>
                  <td className="pp-num">{formatCurrency(c.commissionToDate)}</td>
                  {isInfluencer && (
                    <td className="pp-window" data-testid="pp-window">
                      {c.commissionEndsPeriod
                        ? t('partnerPortal.conversions.windowUntil', {
                            period: formatPeriod(c.commissionEndsPeriod),
                          })
                        : '—'}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default PartnerConversionsTable;
